import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_LOCAL_API_URL;

function ResetPassword() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  async function submit(event) {
    event.preventDefault();
    if (password !== confirm) return setError("Lösenorden matchar inte");
    try {
      const response = await axios.post(`${API_URL}/auth/reset-password`, { token: params.get("token"), newPassword: password });
      setMessage(response.data.message);
      setError("");
    } catch (requestError) {
      setError(requestError.response?.data?.message || "Lösenordet kunde inte återställas");
    }
  }

  return <div className="mx-auto w-full max-w-xl px-4 py-6"><div className="theme-card">
    <h1 className="text-lg font-bold text-slate-800">Välj nytt lösenord</h1>
    <form onSubmit={submit} className="mt-4 grid gap-3">
      <input className="theme-input" type="password" minLength="8" value={password} onChange={(event) => setPassword(event.target.value)} placeholder="Nytt lösenord" required />
      <input className="theme-input" type="password" minLength="8" value={confirm} onChange={(event) => setConfirm(event.target.value)} placeholder="Bekräfta lösenord" required />
      <button className="theme-button-primary" type="submit">Spara nytt lösenord</button>
    </form>
    {message && <div className="theme-alert-success mt-4">{message} <Link className="underline" to="/login">Logga in</Link></div>}
    {error && <div className="theme-alert-error mt-4">{error}</div>}
  </div></div>;
}

export default ResetPassword;
